import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateConstants } from '../../utilities/WeekSchedule/DateConstants';
import * as moment from 'moment';
declare var $:any;
@Component({
  selector: 'date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.css']
})
export class DateTimePickerComponent implements OnInit,AfterViewInit {

  dateTimeForm : FormGroup;
  @Output() onFullDate : EventEmitter<any> = new EventEmitter();
  constructor() {
    this.dateTimeForm = new FormGroup({
      hourInput:new FormControl(12,[Validators.required]),
      minuteInput:new FormControl('00',[Validators.required]),
      amPmInput: new FormControl('AM',[Validators.required])
    })
  }

  isValid(controlName) {
    var control = this.dateTimeForm.get(controlName);
    if (control.touched && control.errors) {
      return false;
    } else {
      return true;
    }
  }

  onHour(event) {
    var value = (event.target as HTMLInputElement).value;
    if(!value){
      this.checkFullDate();
      return;
    }
    if (value && parseInt(value) < 1 || (isNaN(parseInt(value)))) {
      this.dateTimeForm.patchValue({
        hourInput:1
      })
    }
    if (value && parseInt(value) > 12) {
      this.dateTimeForm.patchValue({
        hourInput:12
      })
    }
    this.checkFullDate();
  }

  onMinute(event) {
    var value = (event.target as HTMLInputElement).value;
    if (value) {
      if (value.length < 2 && parseInt(value) > 0) {
        this.dateTimeForm.patchValue({
          minuteInput:`0${value}`
        });
      }
      if (value.length > 2) {
        if (value[0] == '0') {
          this.dateTimeForm.patchValue({
            minuteInput:value.substring(1, (value.length))
          });
        } else {
          this.dateTimeForm.patchValue({
            minuteInput:value.substring(0, 2)
          });
        }
      }
      if (parseInt(value) < 0) {
        this.dateTimeForm.patchValue({
          minuteInput:'00'
        });
      }
      if (parseInt(value) > 59) {
        this.dateTimeForm.patchValue({
          minuteInput:'59'
        });
      }
      if (value == '0') {
        this.dateTimeForm.patchValue({
          minuteInput:"00"
        });
      }
    }
    this.checkFullDate();
  }

  onAmPm() {
    this.checkFullDate();
  }


  checkFullDate() {
    var values = this.dateTimeForm.getRawValue();
    var fullDate = `${moment(values.date).format(DateConstants.standardDateFormat)} ${values.hourInput}:${values.minuteInput} ${values.amPmInput}`;
    try {
      var result = moment(fullDate).format(DateConstants.standard24hHrDateTimeFormat)
      if (result != 'Invalid date') {
        this.onFullDate.emit({
          date: result
        });
        return true;
      }else{
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  ngOnInit() {
  }


  ngAfterViewInit(): void {
    $(document).ready(() => {
      $('#dtp_picker').daterangepicker({
        singleDatePicker: true,
      }, (sD : moment.Moment, eD : moment.Moment, label) => {

      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/date-time-picker/date-time-picker.component.ts